import React, { Component } from 'react';
import * as helpers from '../../../../../../helpers/helpers.js';
import url from 'url';
import GeoJSON from 'ol/format/GeoJSON.js';
import { unByKey } from 'ol/Observable.js';
import VectorSource from 'ol/source/Vector.js';
import VectorLayer from 'ol/layer/Vector.js';
import { Fill, Icon, Stroke, Style } from 'ol/style.js';
import CircleStyle from 'ol/style/Circle.js';
import SelectedElementMessage from './SelectedElementMessage.jsx';
import highlightIcon from './images/highlight.png';

class SelectElement extends Component {
  constructor(props) {
    super(props);

    this.state = {
      visible: true,
      layer: this.initLayer(),
      styleUrl: null,
      recordCount: null,
      elementId: null,
    };

    this.highlightSource = new VectorSource();
    this.highlightLayer = new VectorLayer({
      source: this.highlightSource,
      style: new Style({
        stroke: new Stroke({ color: 'red', width: 20 }),
        fill: new Fill({ color: 'rgba(255, 0, 0, 1)' }),
      }),
    });
  }

  initLayer = () => {
    const apiUrl = process.env.REACT_APP_BACKEND_API;
    const layer = helpers.getImageWMSLayer(
      url.resolve(`${apiUrl}/operations/`, 'wms'),
      this.props.layerName,
      'geoserver',
      null,
      50
    );
    layer.setVisible(true);
    layer.setZIndex(204);
    layer.setProperties({
      name: this.props.layerName,
      tocDisplayName: 'Odabran elemenat',
      queryable: true,
      disableParcelClick: true,
    });
    window.map.addLayer(layer);
    return layer;
  };

  componentDidMount() {
    const apiUrl = process.env.REACT_APP_BACKEND_API
    try {
      window.map.addLayer(this.highlightLayer);
      this.highlightLayer.setZIndex(203);
    } catch (error) {
      console.error('Error adding layers to the map', error);
      return;
    }

    helpers.getWFSLayerRecordCount(
      `${apiUrl}/operations/`,
      this.props.layerName,
      (count) => {
        this.setState({ recordCount: count });
      }
    );

    this.mapClickEvent = window.map.on('click', (evt) => {
      if (
        window.isDrawingOrEditing ||
        window.isCoordinateToolOpen ||
        window.isMeasuring
      )
        return;

      if (!this.state.visible) return;

      var viewResolution = window.map.getView().getResolution();
      var url = this.state.layer
        .getSource()
        .getFeatureInfoUrl(evt.coordinate, viewResolution, 'EPSG:3857', {
          INFO_FORMAT: 'application/json',
        });
      if (url) {
        helpers.getJSON(url, (result) => {
          const features = result.features;
          if (features.length === 0) {
            return;
          }

          const geoJSON = new GeoJSON().readFeatures(result);
          const feature = geoJSON[0];

          this.highlightSource.clear();
          const highlightedFeature = feature.clone();
          this.highlightSource.addFeature(highlightedFeature);

          const fullFeatureId = feature.getId();
          const featureIdSeparated = fullFeatureId.split('.');
          const selectedFeatureId = featureIdSeparated[1];
          const selectedFeatureLayerName = featureIdSeparated[0];

          const rotation = feature.get('ugao') || 0;

          this.setState({ elementId: selectedFeatureId });

          const highlightedFeatureType = highlightedFeature
            .getGeometry()
            .getType();

          if (
            highlightedFeatureType === 'MultiLineString' ||
            highlightedFeatureType === 'LineString'
          ) {
            this.highlightLayer.setZIndex(205);
            highlightedFeature.setStyle(
              new Style({
                stroke: new Stroke({
                  color: 'rgba(255, 255, 204, 0.7)',
                  width: 12,
                }),
                fill: new Fill({ color: 'rgb(255, 255, 204)' }),
              })
            );
          } else if (highlightedFeatureType === 'MultiPolygon') {
            highlightedFeature.setStyle(
              new Style({
                stroke: new Stroke({
                  color: 'rgba(230, 224, 224, 0.8)',
                  width: 15,
                }),
                fill: new Fill({
                  color: 'rgba(238, 238, 172, 0.4)',
                }),
              }),

              new Style({
                stroke: new Stroke({
                  color: 'rgba(200, 200, 200, 0.5)',
                  width: 6,
                }),
                fill: new Fill({
                  color: 'rgba(255, 255, 255, 0.3)',
                }),
              }),

              new Style({
                stroke: new Stroke({
                  color: 'rgba(255, 255, 255, 0.7)',
                  width: 2,
                }),
                fill: new Fill({
                  color: 'rgba(255, 255, 255, 0.65)',
                }),
              })
            );
          } else if (
            feature.values_.namjena === 'Hidrant' ||
            selectedFeatureLayerName === 'Reducir ventil'
          ) {
            highlightedFeature.setStyle(
              new Style({
                image: new Icon({
                  src: highlightIcon,
                  scale: 0.2,
                  rotation: rotation * (Math.PI / 180),
                  anchor:
                    selectedFeatureLayerName === 'Reducir ventil'
                      ? [0.6, 0.5]
                      : [0.5, 0.7],
                  anchorOrigin: 'center',
                  rotateWithView: false,
                }),
              })
            );
          } else {
            highlightedFeature.setStyle([
              new Style({
                image: new CircleStyle({
                  radius: 24,
                  fill: new Fill({ color: 'rgb(230, 224, 224)' }),
                }),
              }),

              new Style({
                image: new CircleStyle({
                  radius: 21,
                  fill: new Fill({ color: 'rgba(238, 238, 172, 0.6)' }),
                  stroke: new Stroke({
                    color: 'rgba(200, 200, 200, 0.5)',
                    width: 3,
                  }),
                }),
              }),
              new Style({
                image: new CircleStyle({
                  radius: 14,
                  fill: new Fill({ color: 'rgba(255, 255, 255, 0.65)' }),
                }),
              }),
            ]);
          }

          window.popup.show(
            evt.coordinate,
            <SelectedElementMessage
              updateSelectedElement={() =>
                this.props.updateSelectedElement(this.state.elementId)
              }
            />,
            'Element označen'
          );
        });
      }
    });
  }

  componentWillUnmount() {
    window.map.removeLayer(this.state.layer);
    window.map.removeLayer(this.highlightLayer);
    unByKey(this.mapClickEvent);
  }

  render() {
    return <></>;
  }
}

export default SelectElement;
